var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20a4.154 4.154 0 11-8.308 0A4.154 4.154 0 0138 20zm-13.846 0a4.154 4.154 0 11-8.309 0 4.154 4.154 0 018.309 0zm-18 4.154a4.154 4.154 0 110-8.309 4.154 4.154 0 010 8.309z"
  })));
}
export default SvgEllipsisVertical;